module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Home/Book-open-50bc083941fa40d80f2a8ec3d55dbc2e.svg";